import { getRequest } from "api/axiosClient";
import {
  GetFreightModesConfigResponseType,
  GetPackingListConfigResponseType,
  GetServiceDetailsConfigResponseType,
  getScheduleOptionResponseType,
} from "api/response";
import { AxiosRequestConfig } from "axios";

const { REACT_APP_CARGOBASE_BASE_URL } = import.meta.env;
const baseURL = `${REACT_APP_CARGOBASE_BASE_URL}/location`;

const getFreightModesConfig = (location: string) =>
  getRequest<GetFreightModesConfigResponseType>(`${baseURL}/${location}/freight-modes`);
const getPackingListConfig = (location: string) =>
  getRequest<GetPackingListConfigResponseType>(`${baseURL}/${location}/packing-list`);
const getServiceDetailsConfig = (location: string) =>
  getRequest<GetServiceDetailsConfigResponseType>(`${baseURL}/${location}/service-details`);
const getScheduleOption = (location: string) =>
  getRequest<getScheduleOptionResponseType>(`${baseURL}/${location}/schedule-options`);
// TODO: Try to remove use for this function
const getAdressTypeOption = (endpoint: string, value: string, config = {}) =>
  getRequest<any>(`${REACT_APP_CARGOBASE_BASE_URL}${endpoint}?q=${value}`, config);
const getCostRecoverySetting = (location: string, config: AxiosRequestConfig = {}) =>
  getRequest(`${baseURL}/${location}/cost-recovery-settings`, config);

export {
  getFreightModesConfig,
  getPackingListConfig,
  getServiceDetailsConfig,
  getScheduleOption,
  getAdressTypeOption,
  getCostRecoverySetting,
};
